import { useState, useEffect } from 'react';
import {
	Row,
	Col,
	Container,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
	Button,
	UncontrolledDropdown,
} from 'reactstrap';
import { useMediaQuery } from 'react-responsive';
import { withRouter } from 'react-router-dom';
import { Player } from 'video-react';
import { connect } from 'react-redux';

import RoundedButton from '../../Buttons/RoundedButton/RoundedButton';
import Loader from '../../Common/Loader';
import TrackWave from '../../Tracks/TrackWave/TrackWave';
import PlayButton from '../../Buttons/PlayButton/PlayButton';

import { loadUser } from '../../../helpers/api/users.api';
import { loadTrackComments } from '../../../helpers/api/tracks.api';

import { showMessageModal } from '../../../store/actions';

import { ReactComponent as FacebookIcon } from '../../../assets/images/fb.svg';
import { ReactComponent as InstagramIcon } from '../../../assets/images/ig.svg';
import { ReactComponent as TiktokIcon } from '../../../assets/images/tt.svg';
import { ReactComponent as YoutubeIcon } from '../../../assets/images/yt.svg';
import { ReactComponent as WebsiteIcon } from '../../../assets/images/web.svg';
import { ReactComponent as ExpandIcon } from '../../../assets/images/expand.svg';
import { ReactComponent as RewardsIcon } from '../../../assets/images/reward.svg';

import './UserDetail.scss';

const UserDetail = (props) => {
	const MOBILE_AND_TABLET = useMediaQuery({
		query: '(max-device-width: 768px)',
	});

	const [loading, setLoading] = useState(true);

	const [user, setUser] = useState(null);

	const [track, setTrack] = useState(null);
	const [trackComments, setTrackComments] = useState([]);

	const [playing, setPlaying] = useState(false);

	useEffect(() => {
		if (props.userId) {
			setLoading(true);
			loadUser(props.userId)
				.then((result) => {
					if (result.success) {
						setUser(result.user);
						if (result.user.type === 'artist' && result.user.tracks && result.user.tracks.length > 0)
							setTrack(result.user.tracks[0]);
					} else console.log(result.message);
					setLoading(false);
				})
				.catch((error) => {
					setLoading(false);
					console.log(error);
				});
		}
	}, [props.userId]);

	useEffect(() => {
		if (track) loadComments();
	}, [track]);

	function loadComments() {
		loadTrackComments(track._id)
			.then((result) => {
				if (result.success) {
					setTrackComments(result.comments);
				} else {
					console.log(result.message);
					setTrackComments([]);
				}
			})
			.catch((error) => {
				setTrackComments([]);
				console.log(error);
			});
	}

	let links = [],
		pics = [];
	if (user) {
		if (user.socialLinks) {
			if (user.socialLinks.instagram)
				links.push(
					<a key="instagram" className="social-link" href={user.socialLinks.instagram} target="_blank">
						<InstagramIcon />
					</a>
				);
			if (user.socialLinks.facebook)
				links.push(
					<a key="facebook" className="social-link" href={user.socialLinks.facebook} target="_blank">
						<FacebookIcon />
					</a>
				);
			if (user.socialLinks.tiktok)
				links.push(
					<a key="tiktok" className="social-link" href={user.socialLinks.tiktok} target="_blank">
						<TiktokIcon />
					</a>
				);
			if (user.socialLinks.youtube)
				links.push(
					<a key="youtube" className="social-link" href={user.socialLinks.youtube} target="_blank">
						<YoutubeIcon />
					</a>
				);
			if (user.socialLinks.website)
				links.push(
					<a key="website" className="social-link" href={user.socialLinks.website} target="_blank">
						<WebsiteIcon />
					</a>
				);
		}
		if (user.pics)
			pics = user.pics.map((p, i) => <img key={'img+' + i} className="artist-pic" src={p.url} alt="" />);
	}

	return loading ? (
		<Loader />
	) : user ? (
		<Container className="user-detail">
			<Row>
				<Col lg="6">
					<Row className="mb-2 mb-lg-5">
						<Col xs="5" lg="4">
							<div
								className="user-pic"
								style={{
									backgroundImage: user.image ? 'url(' + user.image.url + ')' : '',
								}}
								alt="profile"
							/>
						</Col>
						<Col
							xs={{
								size: 7,
								offset: 0,
							}}
							lg={{
								size: 7,
								offset: 1,
							}}
						>
							<h3>{user.name}</h3>
							<h6>
								<i>{user.type === 'scout' ? user.job : (user.artistType?.charAt(0).toUpperCase() + user.artistType?.slice(1))}</i>
							</h6>
							<h6>{user.city}</h6>
							<div className="d-block mt-3">{links}</div>
							{MOBILE_AND_TABLET && (
								<RoundedButton
									className="ml-0 mt-4 w-75"
									color="primary"
									onClick={() => {
										props.history.push('/settings');
									}}
								>
									Modifica
								</RoundedButton>
							)}
						</Col>
					</Row>

					{!MOBILE_AND_TABLET && (
						<Row>
							<Col>
								{!props.user || props.user.type === 'admin' ? null : props.user._id !== user._id ? (
									<RoundedButton
										className="px-4"
										color="primary"
										onClick={() => props.showMessageModal && props.showMessageModal(user)}
									>
										Invia Messaggio
									</RoundedButton>
								) : (
									<>
										<RoundedButton
											className="px-5"
											color="primary"
											onClick={() => {
												props.history.push('/dashboard');
											}}
										>
											Dashboard
										</RoundedButton>
										<RoundedButton
											className="px-5 ml-4"
											color="secondary"
											onClick={() => {
												props.history.push('/settings');
											}}
										>
											Modifica
										</RoundedButton>
									</>
								)}
							</Col>
						</Row>
					)}

					{user.type === 'scout' || (user.type === 'artist' && MOBILE_AND_TABLET) ? (
						<Row className="mt-lg-5">
							<Col>
								<h3>Bio</h3>
								<p className="user-bio mb-4">{user.bio}</p>
							</Col>
						</Row>
					) : null}

					{track ? (
						<Row className="mt-4 mt-lg-5">
							<Col>
								<div className="w-100 d-flex justify-content-between">
									<div className="d-flex align-items-center">
										<div className="d-flex flex-column mr-4">
											<h6>
												<i>Brani</i>
											</h6>
											<UncontrolledDropdown>
												<DropdownToggle>
													<h6>{track.title}</h6>
													<Button color="link" className="expand-button d-inline">
														<ExpandIcon />
													</Button>
												</DropdownToggle>
												<DropdownMenu>
													{user.tracks
														.filter((t) => t._id !== track._id)
														.map((t) => (
															<DropdownItem key={t._id} onClick={() => setTrack(t)}>
																{t.title}
															</DropdownItem>
														))}
												</DropdownMenu>
											</UncontrolledDropdown>
										</div>
										<PlayButton playing={playing} onClick={() => setPlaying(!playing)} />
									</div>
									<div className="d-none d-lg-flex align-items-center justify-content-end">
										<p className="track-points">
											{track.points || 0}
											{' punti'}
										</p>
										<p className="track-rewards">
											<RewardsIcon />
											{track.rewards ? track.rewards.length : 0}
											{' Rewards'}
										</p>
									</div>
								</div>
								<div className="wave-wrapper mt-3 mt-lg-5">
									<TrackWave
										id={track._id}
										audioFile={track.file.url}
										comments={trackComments}
										playing={playing}
									/>
								</div>
								{/* {props.user.type === 'scout' &&
                                    <div className="d-flex align-items-center justify-content-between mb-4">
                                        <RoundedButton onClick={() => setMakingAction('comment')} className="px-5">COMMENTA</RoundedButton>
                                        <RoundedButton onClick={() => setMakingAction('vote')} className="px-5">ASSEGNA VOTO</RoundedButton>
                                        <RoundedButton onClick={() => setMakingAction('save')} className="px-5">SALVA</RoundedButton>
                                        <RoundedButton onClick={() => setMakingAction('reward')} className="px-5">REWARD</RoundedButton>
                                    </div>}
                                <CommentTrackModal isOpen={makingAction === 'comment'} track={track} time={time} onClose={() => setMakingAction('')} onSuccess={() => loadComments()} />
                                <VoteTrackModal isOpen={makingAction === 'vote'} track={track} onClose={() => setMakingAction('')} />
                                <SaveTrackModal isOpen={makingAction === 'save'} track={track} onClose={() => setMakingAction('')} />
                                <RewardTrackModal isOpen={makingAction === 'reward'} track={track} onClose={() => setMakingAction('')} /> */}
							</Col>
						</Row>
					) : null}
				</Col>

				{user.type === 'artist' && (
					<Col lg={{ offset: 1, size: 5 }}>
						<Row className="mb-4 mb-lg-5">
							<Col>
								<h3>Foto</h3>
								<div className="mt-4">{pics}</div>
							</Col>
						</Row>
						<Row className="d-none d-lg-flex mb-4 mb-lg-5">
							<Col>
								<h3>Bio</h3>
								<p className="user-bio mb-0">{user.bio}</p>
							</Col>
						</Row>
						<Row>
							<Col>
								<h3>Media</h3>
								<div className="mt-4 mb-4 mb-lg-5">
									<Player
										playsInline
										//   poster="/assets/poster.png"
										src={user.videoUrl}
									/>
								</div>
							</Col>
						</Row>
						{MOBILE_AND_TABLET && (
							<Row>
								<Col>
									<h3>Brani pubblicati</h3>
									<p className="big mb-4 mb-lg-5">
										<b>{user.releases ? user.releases.reduce((acc, r) => {
											return acc + Number(r.nTracks);
										}, 0) : 0}</b>
									</p>
									<h3>Componenti</h3>
									<p className="big mb-4 mb-lg-5">
										<b>{user.nMembers || 1}</b>
									</p>
									<div className="releases">
										<h3>Pubblicazioni</h3>
										{user.releases?.map((r, i) => (
											<div className="release-row pb-4 mb-4 mb-lg-5">
												<Row>
													<Col xs="4">
														<h6>
															<i>Tipologia</i>
														</h6>
														<p className="mb-2">
															<b>{r.type?.charAt(0).toUpperCase() + r.type.slice(1)}</b>
														</p>
													</Col>
													<Col xs="4">
														<h6>
															<i>Titolo</i>
														</h6>
														<p className="mb-2">
															<b>{r.title}</b>
														</p>
													</Col>
													<Col xs="3">
														<h6>
															<i>Cover</i>
														</h6>
														<img className="d-block mb-2" src={r.coverUrl} />
													</Col>
													<Col xs="4">
														<h6>
															<i>Anno</i>
														</h6>
														<p className="mb-2">
															<b>{r.year}</b>
														</p>
													</Col>
													<Col xs="4">
														<h6>
															<i>N° Tracce</i>
														</h6>
														<p className="mb-2">
															<b>{r.nTracks}</b>
														</p>
													</Col>
												</Row>
											</div>
										))}
									</div>
									<div className="concerts">
										<h3>Storico concerti</h3>
										{user.concerts?.map((c, i) => (
											<div className="concert-row pb-4 mb-4 mb-lg-5">
												<Row>
													<Col xs="6">
														<h6>
															<i>Evento</i>
														</h6>
														<p className="mb-2">
															<b>{c.name}</b>
														</p>
													</Col>
													<Col xs="6">
														<h6>
															<i>Luogo</i>
														</h6>
														<p className="mb-2">
															<b>{c.location}</b>
														</p>
													</Col>
												</Row>
												<Row>
													<Col xs="6">
														<h6>
															<i>Data</i>
														</h6>
														<p className="mb-2">
															<b>{c.date}</b>
														</p>
													</Col>
													<Col xs="6">
														<h6>
															<i>Informazioni</i>
														</h6>
														<p className="mb-2">{c.info}</p>
													</Col>
												</Row>
											</div>
										))}
									</div>
									<div className="awards">
										<h3>Riconoscimenti</h3>
										{user.awards?.map((a, i) => (
											<div className="award-row pb-4 mb-4 mb-lg-5">
												<Row>
													<Col xs="6">
														<h6>
															<i>Nome</i>
														</h6>
														<p className="mb-2">
															<b>{a.name}</b>
														</p>
													</Col>
													<Col xs="6">
														<h6>
															<i>Informazioni</i>
														</h6>
														<p className="mb-2">{a.info}</p>
													</Col>
												</Row>
											</div>
										))}
									</div>

									<h3>Label</h3>
									<p className="mb-4 mb-lg-5">{user.label}</p>

									<h3>Management</h3>
									<p className="mb-4 mb-lg-5">{user.management}</p>

									<h3>Collecting</h3>
									<p className="mb-4 mb-lg-0">{user.collecting}</p>
								</Col>
							</Row>
						)}
					</Col>
				)}
			</Row>

			{user.type === 'artist' && !MOBILE_AND_TABLET && (
				<>
					<Row>
						<Col lg="6">
							<div className="releases">
								<h3>Pubblicazioni</h3>
								{user.releases?.map((r, i) => (
									<div className="release-row mb-4">
										<Row>
											<Col xs="4">
												<h6>
													<i>Tipologia</i>
												</h6>
												<p className="mb-2">
													<b>{r.type?.charAt(0).toUpperCase() + r.type?.slice(1)}</b>
												</p>
												<h6>
													<i>Anno</i>
												</h6>
												<p className="mb-2">
													<b>{r.year}</b>
												</p>
											</Col>
											<Col xs="4">
												<h6>
													<i>Titolo</i>
												</h6>
												<p className="mb-2">
													<b>{r.title}</b>
												</p>
												<h6>
													<i>N° Tracce</i>
												</h6>
												<p className="mb-2">
													<b>{r.nTracks}</b>
												</p>
											</Col>
											<Col xs="3">
												<h6>
													<i>Cover</i>
												</h6>
												<img className="d-block mb-2" src={r.coverUrl} />
											</Col>
										</Row>
									</div>
								))}
							</div>
							<div className="concerts">
								<h3>Storico concerti</h3>
								{user.concerts?.map((c, i) => (
									<div className="concert-row mb-5">
										<Row>
											<Col xs="6">
												<h6>
													<i>Evento</i>
												</h6>
												<p className="mb-2">
													<b>{c.name}</b>
												</p>
											</Col>
											<Col xs="6">
												<h6>
													<i>Luogo</i>
												</h6>
												<p className="mb-2">
													<b>{c.location}</b>
												</p>
											</Col>
										</Row>
										<Row>
											<Col xs="6">
												<h6>
													<i>Data</i>
												</h6>
												<p className="mb-2">
													<b>{c.date}</b>
												</p>
											</Col>
											<Col xs="6">
												<h6>
													<i>Informazioni</i>
												</h6>
												<p className="mb-2">{c.info}</p>
											</Col>
										</Row>
									</div>
								))}
							</div>
							<div className="awards">
								<h3>Riconoscimenti</h3>
								{user.awards?.map((a, i) => (
									<div className="award-row mb-4">
										<Row>
											<Col xs="6">
												<h6>
													<i>Nome</i>
												</h6>
												<p className="mb-2">
													<b>{a.name}</b>
												</p>
											</Col>
											<Col xs="6">
												<h6>
													<i>Informazioni</i>
												</h6>
												<p className="mb-2">{a.info}</p>
											</Col>
										</Row>
									</div>
								))}
							</div>
						</Col>
						<Col lg={{ offset: 1, size: 5 }}>
							<h3>Brani pubblicati</h3>
							<p className="big mb-4">
								<b>{user.releases ? user.releases.reduce((acc, r) => {
									return acc + Number(r.nTracks);
								}, 0) : 0}</b>
							</p>
							<h3>Componenti</h3>
							<p className="big">
								<b>{user.nMembers || 1}</b>
							</p>
						</Col>
					</Row>
					<Row>
						<Col>
							<h3>Label</h3>
							<p className="mb-4">{user.label}</p>
						</Col>
						<Col>
							<h3>Management</h3>
							<p className="mb-4">{user.management}</p>
						</Col>
						<Col>
							<h3>Collecting</h3>
							<p className="mb-4">{user.collecting}</p>
						</Col>
					</Row>
				</>
			)}
		</Container>
	) : null;
};

const mapStatetoProps = (state) => {
	const { error, success, user } = state.Auth;
	return { error, success, user };
};
export default withRouter(
	connect(mapStatetoProps, {
		showMessageModal,
	})(UserDetail)
);
